module.exports = __webpack_public_path__ + "static/media/tvplay-logo.19235f26.png";